import { CharacteristicType } from '@/helper/Types'
import { Product } from '@/services/models/implementations/Product'
import { SystemControllerCharacteristic } from '@/services/models/SystemControllerCharacteristic.ts'

export class SystemController extends Product {
  public get chr(): SystemControllerCharacteristic {
    return this.getProductCharacteristic<SystemControllerCharacteristic>(CharacteristicType.SYSTEM_CONTROLLER)
  }
}
